import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faPlayPause } from '@fortawesome/pro-light-svg-icons/faPlayPause';
import { faListMusic } from '@fortawesome/pro-light-svg-icons/faListMusic';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { TypedMemo } from '../../../common/types';
import { SMLLink } from '../SMLLink/SMLLink';
import { SMLRoutes, SMLRouteParts } from '../../../../routing/sml/SMLRoutes';
import { Panel, PanelBody, PanelHead } from '../primitives/Panel';
import styles from './FollowingTiles.module.scss';

interface FollowingTilesProps {
  artistsTotal: number;
  tracksTotal: number;
  playlistsTotal: number;
  dateValue?: string;
}

const FollowingTilesComponent: React.FC<FollowingTilesProps> = ({
  artistsTotal,
  tracksTotal,
  playlistsTotal,
  dateValue,
}) => {
  const intl = useIntl();
  const params = dateValue !== undefined ? { date: dateValue } : undefined;

  const tiles: Array<{ key: string; icon: typeof faUsers; value: number; label: string; route: SMLRouteParts }> = [
    {
      key: 'artists',
      icon: faUsers,
      value: artistsTotal,
      label: intl.formatMessage({ id: 'app.sml.home.kpi.followedArtists', defaultMessage: 'Followed Artists' }),
      route: SMLRoutes.artists,
    },
    {
      key: 'tracks',
      icon: faPlayPause,
      value: tracksTotal,
      label: intl.formatMessage({ id: 'app.sml.home.kpi.followedTracks', defaultMessage: 'Followed Tracks' }),
      route: SMLRoutes.tracks,
    },
    {
      key: 'playlists',
      icon: faListMusic,
      value: playlistsTotal,
      label: intl.formatMessage({ id: 'app.sml.home.kpi.followedPlaylists', defaultMessage: 'Followed Playlists' }),
      route: SMLRoutes.playlists,
    },
  ];

  return (
    <Panel className="h-100">
      <PanelHead title={intl.formatMessage({ id: 'app.sml.home.following.label', defaultMessage: 'Following' })} />
      <PanelBody flush className={styles.list}>
        {tiles.map((tile) => (
          <SMLLink key={tile.key} to={tile.route} params={params} className={styles.tile}>
            <div className={styles.iconTile}>
              <FontAwesomeIcon icon={tile.icon} />
            </div>
            <div className={styles.body}>
              <div className={styles.value}>{tile.value.toLocaleString(intl.locale)}</div>
              <div className={styles.sub}>{tile.label}</div>
            </div>
            <FontAwesomeIcon icon={faChevronRight} className={styles.chev} />
          </SMLLink>
        ))}
      </PanelBody>
    </Panel>
  );
};

export const FollowingTiles = TypedMemo(FollowingTilesComponent);
